import { getAudioTrackSnapshots, hasPublishedAudioTrack } from './stream.service';
import { MediaUserRole, type MediaRoom } from './utils/liveMedia.utils';

import analytics, { SEGMENT_EVENTS } from '@/analytics';
import store from '@/store';

const AUDIO_RECOVERY_TIMEOUT_MS = 8000;
const audioRecoveryTimers = new Map<string, NodeJS.Timeout>();

export function scheduleAudioRecovery(mediaRoom: MediaRoom): void {
  if (!store.state.event.useAutoAudioRecover) {
    return;
  }

  const { channelName } = mediaRoom;
  if (mediaRoom.userRole !== MediaUserRole.host || mediaRoom.status !== 'CONNECTED') {
    return;
  }
  if (audioRecoveryTimers.has(channelName)) {
    return;
  }

  const timer = setTimeout(() => {
    audioRecoveryTimers.delete(channelName);
    if (!hasPublishedAudioTrack(channelName)) {
      return;
    }

    const [snapshot] = getAudioTrackSnapshots(channelName);
    analytics.track(SEGMENT_EVENTS.audio_recovery_triggered, {
      channelName,
      trackStatus: snapshot?.trackStatus,
      readyState: snapshot?.readyState,
      reason: 'exception_no_recovery',
      eventId: store.state.route.params?.eventID,
      organizationId: store.state.event.organization?.id
    });
    store.dispatch('mediaroom/recreateAudioTrack', { channelName, reason: 'exception_no_recovery' });
  }, AUDIO_RECOVERY_TIMEOUT_MS);

  audioRecoveryTimers.set(channelName, timer);
}

export function cancelAudioRecovery(channelName: string): void {
  const timer = audioRecoveryTimers.get(channelName);
  if (timer) {
    clearTimeout(timer);
    audioRecoveryTimers.delete(channelName);
  }
}
